export function getDataFromLocalStorage<T>(label: string): T | null {
  const stringifyValue = localStorage.getItem(label);

  return stringifyValue ? JSON.parse(stringifyValue) : null;
}
